import { useMemo } from "react";
import { env } from "../../../env";

interface Props {
    json: any;
}

export const PrintJson = ({ json }: Props) => {
    const print = env.PRINT_LOG ?? false;

    const parsedJson = useMemo(() => {
        if (!print) return null;

        try {
            return typeof json === 'string' ? JSON.parse(json) : json;
        } catch {
            return json; // Si no se puede parsear, devuelve como está
        }
    }, [json, print]);

    if (!print) return null;

    return (
        <div>
            <pre>{JSON.stringify(parsedJson, null, 2)}</pre>
        </div>
    );
};
